import { Plus } from 'lucide-react';
import { UDButton, UDText } from 'ud-ui/components';
import UDEmptyState from 'ud-ui/components/empty-state';

export interface StageGroupEmptyProps {
  onAddClick?: () => void;
}

const StageGroupEmpty = (props: StageGroupEmptyProps) => {
  return (
    <UDEmptyState
      className={'bordered-block flex-center h-60 gap-5'}
      title={<UDText variant={'body-3'}>Список групп пуст. Создайте группы задав название</UDText>}
      action={
        <UDButton variant={'primary'} onClick={props.onAddClick}>
          <Plus size={20} className="mr-2" />
          Создать
        </UDButton>
      }
    />
  );
};

export default StageGroupEmpty;
